import {useState} from "react";
import {Autocomplete, Box, IconButton, MenuItem, Select, TextField, Typography} from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import AddCircleIcon from "@mui/icons-material/AddCircle";
import PropTypes from "prop-types";
import LoadingBackdrop from "../../../components/LoadingBackdrop";

/**
 * Component for managing suppression lists
 * @param props
 * @constructor
 */
export default function SuppressionSelector(props){

    const suppressionListOptions = props.suppressionOptions;
    const suppressionListMenu = [];
    const suppressionListLK = {};
    for (let i = 0; i < suppressionListOptions.length; i += 1) {
        // suppressionListMenu.push(
        //     <MenuItem
        //         value={suppressionListOptions[i].listId}>{suppressionListOptions[i].name} ({suppressionListOptions[i].type} -> {suppressionListOptions[i].listId})</MenuItem>
        // )
        suppressionListMenu.push(`${suppressionListOptions[i].name} (${suppressionListOptions[i].type} -> ${suppressionListOptions[i].listId})`);
        suppressionListLK[`${suppressionListOptions[i].name} (${suppressionListOptions[i].type} -> ${suppressionListOptions[i].listId})`] = suppressionListOptions[i].listId;
        suppressionListLK[suppressionListOptions[i].listId] = `${suppressionListOptions[i].name} (${suppressionListOptions[i].type} -> ${suppressionListOptions[i].listId})`;
    }

    const suppressions = props.suppressions ? props.suppressions : [];
    const suppressionElements = [];
    for (let i = 0; i < suppressions.length; i += 1) {
        const indexCnt = i;
        suppressionElements.push(<span style={{"display": "flex"}} id={`suppression${i}`}>
                        <Autocomplete
                            id={`suppress${i}`}
                            options={suppressionListMenu}
                            value={suppressions[i]? suppressionListLK[suppressions[i]]:""}
                            error={suppressions[i].length < 3 ? 1 : 0}
                            color={suppressions[i].length >= 3 ? 'success' : 'error'}
                            multiple={false}
                            fullWidth
                            freesolo={false}
                            onChange={(event, newValue) => {
                                 // console.log(e.target.value);
                                 const supp = [...suppressions];
                                 supp[indexCnt] = suppressionListLK[newValue];
                                 props.setSuppressions(supp);
                            }}
                            renderInput={params => <TextField {...params}
                                      error={suppressions[i].length < 3 ? 1 : 0}
                                      color={suppressions[i].length >= 3 ? 'success' : 'error'}
                            />}
                        />
                        <IconButton aria-label="delete" onClick={() => {
                            console.log(indexCnt);
                            const supp = [...suppressions];
                            supp.splice(indexCnt, 1);
                            props.setSuppressions(supp)
                        }}>
                          <DeleteIcon/>
                        </IconButton>
                       </span>)
    }

    return <>
        <Typography align="left" variant={"h5"}>
            Add Suppression Lists&nbsp;&nbsp;&nbsp;
            <IconButton aria-label="create" onClick={() => {
                // TODO Something Here
                props.setSuppressions([...suppressions, ""])
            }}>
                <AddCircleIcon color={"success"}/>
            </IconButton>
        </Typography>
        {suppressionElements}

    </>
}


SuppressionSelector.propTypes= {
    suppressionOptions: PropTypes.array,
    suppressions: PropTypes.array,
    setSuppressions: PropTypes.func,
}